export default __webpack_public_path__ + "static/media/faculty.4f7a38af.jpeg";